// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/.pnpm/webpack-dev-server@5.2.3_debug@4.4.3_tslib@2.8.1_webpack-cli@5.1.4_webpack@5.105.2/node_modules/webpack-dev-server/client/index.js?protocol=ws%3A&hostname=0.0.0.0&port=5001&pathname=%2Fws&logging=info&overlay=true&reconnect=10&hot=true&live-reload=true");
__webpack_require__("./node_modules/.pnpm/webpack@5.105.2_@swc+core@1.15.11_webpack-cli@5.1.4/node_modules/webpack/hot/dev-server.js");
var __webpack_exports__ = __webpack_require__("./src/sass/dpa-print.scss");
